/*
 * @Author: 神农西瓜
 * @Date: 2021-05-12 20:40:48
 * @LastEditTime: 2021-11-30 13:59:48
 * @LastEditors: 神农西瓜
 * @Description: 
 * @FilePath: /otherFiles/STO_ERP/src/config/global.js
 */
let APP_ID; // 飞书自建程序appid
let SERVER; // 线上地址
let BASE_URL; // api地址
let REDIRECT_URI; // 飞书登陆回调url
let APP_LINK_FLAG; // 是否开启飞书 AppLink 跳转

console.log(process.env.VUE_APP_TITLE);
// 判断当前是否为生产环境
if (process.env.VUE_APP_TITLE == "production") {
  // 生产环境
  APP_ID = "cli_a72b312081b9d00b";
  SERVER = "https://mgroup.ht-tek.com";
  BASE_URL = "https://group.ht-tek.com";
  REDIRECT_URI = SERVER;
  APP_LINK_FLAG = false;
} else {
  // 测试环境
  APP_ID = "cli_a0b0b28ff7b8900d";
  SERVER = "https://sto.toasin.cn";
  // BASE_URL = "http://www.cerp.test";
  BASE_URL = "http://wfcl.stone.com";
  REDIRECT_URI = SERVER;
  APP_LINK_FLAG = false;
}
export { SERVER, BASE_URL, REDIRECT_URI, APP_LINK_FLAG, APP_ID };
